import axios from 'axios'
import {getAccessToken, getReservoirApiUrl} from './vu'

// export const get = (urlPath, options = {}) => {
//   return getAccessToken().then(accessToken => {
//     return axios
//       .get(`/jsonapi/${urlPath}`, Object.assign({}, options, {
//         headers: {
//           'Authorization': `Bearer ${accessToken}`
//         }
//       }))
//       .then(response => response.data)
//   })
// }

export const get = (urlPath, options = {}) => {
  return getAccessToken().then(accessToken => {
    return axios
      .get(getReservoirApiUrl(urlPath), Object.assign({}, options, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      }))
      .then(response => response.data)
  })
}

export const getJsonApiData = (urlPath, options = {}) => {
  return get(urlPath, options).then(response => response.data)
}

export const getArticles = () => {
  return get('node/article')
}

export const getHelperTextForPage = pageName => {
  const helperTextCacheName = `HELPER_TEXT_${pageName}`

  if (!sessionStorage.getItem(helperTextCacheName)) {
    return get('node/enrol_helper', {
      params: {
        'filter[field_enrol_page_name.name][value]': pageName
      }
    }).then(response => {
      sessionStorage.setItem(helperTextCacheName, JSON.stringify(response))

      return response
    })
  }

  return new Promise(resolve => {
    resolve(JSON.parse(sessionStorage.getItem(helperTextCacheName)))
  })
}

export const getEnrolPages = pageName => {
  return get('taxonomy_term/enrol_pages', {
    params: {
      'filter[name.name][value]': pageName
    }
  })
}

export const getLegalTextForPage = pageName => {
  const legalTextCacheName = `LEGAL_TEXT_${pageName}`

  if (!sessionStorage.getItem(legalTextCacheName)) {
    return get('node/legal_text', {
      params: {
        'filter[field_legal_page.name][value]': pageName
      }
    }).then(response => {
      sessionStorage.setItem(legalTextCacheName, JSON.stringify(response))

      return response
    })
  }

  return new Promise(resolve => {
    resolve(JSON.parse(sessionStorage.getItem(legalTextCacheName)))
  })
}

export const getTooltipsForPage = pageName => {
  const tooltipCacheName = `TOOLTIP_${pageName}`

  if (!sessionStorage.getItem(tooltipCacheName)) {
    return get('node/tooltip', {
      params: {
        'filter[field_enrol_page_name.name][value]': pageName
      }
    }).then(response => {
      sessionStorage.setItem(tooltipCacheName, JSON.stringify(response))

      return response
    })
  }

  return new Promise(resolve => {
    resolve(JSON.parse(sessionStorage.getItem(tooltipCacheName)))
  })
}

export const getFinanceSupportFormLink = id => {
  const tooltipCacheName = `LINKS_${id}`

  if (!sessionStorage.getItem(tooltipCacheName)) {
    return get('node/cia_links', {
      params: {
        'filter[field_id][value]': id
      }
    }).then(response => {
      let url = response.data[0].attributes.field_link.uri
      sessionStorage.setItem(tooltipCacheName, url)
      return url
    })
  }

  return new Promise(resolve => {
    resolve(sessionStorage.getItem(tooltipCacheName))
  })
}

export const getModalsBySlug = slug => get('node/modal', {
  params: {
    'filter[field_slug][value]': slug
  }
})

export const getStudentSanctionContentBySanctionType = sanctionType => {
  return getJsonApiData('node/student_sanctions', {
    params: {
      'filter[field_sanction_hold.field_sanction_type][condition][path]': 'field_sanction_hold.field_sanction_type', // Filter by the sanction type
      'filter[field_sanction_hold.field_sanction_type][value]': sanctionType
    }
  })
}

export const getTemporaryCustomMessages = id => {
  return get('node/temporary_messages').then(response => {
    const now = new Date();
    
    return response.data
      .filter(item => {
        const { field_message_date_range, field_temp_message_id, status } = item.attributes;
        const start = new Date(field_message_date_range.value);
        const end = new Date(field_message_date_range.end_value);

        return now >= start && now <= end && status; // ✅ keep only active
      })
      .filter(item => {
        return item.attributes.field_temp_message_id === id
      })
      .map(item => {
        const { title, body, field_temp_message_id } = item.attributes;

        return {
          id: field_temp_message_id,
          title,
          value: body.value
        };
      });
  });
};